"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readableCycleNumber = exports.readableSubjectSmsType = exports.readableWhoDDColumnType = exports.readableMedicalCodingEntryType = exports.readableSubjectCrfDisablingStatus = exports.readableStudyPhase = exports.readableStudyUserActivateStatus = exports.convertFlagToReadableText = exports.readableStudyIpAccountabilityBySubjectType = exports.readableStudyDigestVerificationStatus = exports.readableStudyDigestHashingStatus = exports.readableStudyDigestType = exports.readableStudyIpReturnStatus = exports.readableStudyIpInfoType = exports.readableStudyIpDeliveryStatus = exports.readableStudyQueryUploadDetailStatus = exports.readableStudyQueryUploadApplyStatus = exports.readableStudyQueryUploadValidateStatus = exports.readableStudyQueryUploadDetailApplyStatus = exports.readableStudyQueryUploadDetailValidateStatus = exports.offsetToTimezone = exports.readableNotificationStatus = exports.readableStudyRandomizationUploadStatus = exports.readableStudyRoleUploadStatus = exports.readableStudyUatVerbStatus = exports.readableStudyUatStatus = exports.readableStudyUatCategory = exports.readableInquiryCategory = exports.readableInquiryType = exports.readableStudyReportStatus = exports.readableVisitName = exports.readableCrfFolderType = exports.readableLabelObject = exports.readableStudySubjectSex = exports.readableStudySubjectSigningStatus = exports.readableStudyCaptureSummaryStatus = exports.readableStudyQueryStatus = exports.readableStudyQueryType = exports.readableStudySubjectStatus = exports.readableStudyStatus = exports.convertAffiliationTypeToUrlString = exports.readableAffiliationType = exports.readableFaqCategory = exports.readableSubjectBlindAction = exports.readableSubjectSigningStatus = exports.readableEcoaCrfStatus = exports.readableEcoaVisitStatus = exports.readableRefAuditReason = exports.readableLang = void 0;
const misc_1 = require("./misc");
const consts_1 = require("../consts");
const common_1 = require("../consts/common");
const faq_1 = require("../consts/faq");
const resource_1 = require("../consts/resource");
const entity_1 = require("../dto/entity");
const affiliation_1 = require("../dto/entity/affiliation");
const studyCaptureSummaryStatus_1 = require("../dto/entity/common/studyCaptureSummaryStatus");
const ecoaCrf_1 = require("../dto/entity/ecoaCrf");
const ecoaVisit_1 = require("../dto/entity/ecoaVisit");
const inquiry_1 = require("../dto/entity/inquiry");
const study_1 = require("../dto/entity/study");
const studyDigest_1 = require("../dto/entity/studyDigest");
const studyIp_1 = require("../dto/entity/studyIp");
const studyQuery_1 = require("../dto/entity/studyQuery");
const studyRandomization_1 = require("../dto/entity/studyRandomization");
const studyReport_1 = require("../dto/entity/studyReport");
const studyRole_1 = require("../dto/entity/studyRole");
const studySubject_1 = require("../dto/entity/studySubject");
const studySubjectBlindAction_1 = require("../dto/entity/studySubjectBlindAction");
const studyUat_1 = require("../dto/entity/studyUat");
const subjectSms_1 = require("../dto/subjectSms");
function readableLang(lang, defaultVal = "-") {
    switch (lang) {
        case common_1.LoLang.EN:
            return "English";
        case common_1.LoLang.KO:
            return "Korean";
        case common_1.LoLang.JA:
            return "Japanese";
        case common_1.LoLang.ZH:
            return "Chinese";
        default:
            return lang || defaultVal;
    }
}
exports.readableLang = readableLang;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function readableRefAuditReason(reason, lang) {
    if (!reason || !reason.key) {
        return reason.typeText || "(Null)";
    }
    switch (reason.key) {
        case resource_1.RefAuditReasonKey.StudySubjectCreate:
            return lang === common_1.LoLang.EN ? "Subject Registered" : "Subject 등록";
        case resource_1.RefAuditReasonKey.StudySubjectInitializationStatusUpdatedToProcessing:
            return lang === common_1.LoLang.EN ? "Subject Initialization Started" : "Subject 초기화 시작";
        case resource_1.RefAuditReasonKey.StudySubjectInitializationStatusUpdatedToProcessed:
            return lang === common_1.LoLang.EN ? "Subject Initialization Completed" : "Subject 초기화 완료";
        case resource_1.RefAuditReasonKey.StudySubjectInitializationStatusUpdatedToFail:
            return lang === common_1.LoLang.EN ? "Subject Initialization Incompleted" : "Subject 초기화 미완료";
        case resource_1.RefAuditReasonKey.StudySubjectMigrate:
            return lang === common_1.LoLang.EN ? "Subject Migrated" : "Subject Migrated";
        case resource_1.RefAuditReasonKey.StudySubjectInit:
            return lang === common_1.LoLang.EN ? "Subject Initialized" : "Subject 초기화";
        case resource_1.RefAuditReasonKey.StudySubjectVisitAdd:
            return lang === common_1.LoLang.EN ? "Subject Visit Added" : "Subject Visit 추가";
        case resource_1.RefAuditReasonKey.StudySubjectVisitRemove:
            return lang === common_1.LoLang.EN ? "Subject Visit Removed" : "Subject Visit 삭제";
        case resource_1.RefAuditReasonKey.StudySubjectVisitInit:
            return lang === common_1.LoLang.EN ? "Subject Visit Initialized" : "Subject Visit 초기화";
        case resource_1.RefAuditReasonKey.StudySubjectSigningStatusChanged:
            return lang === common_1.LoLang.EN ? "Subject eSignature Status Updated" : "전자서명 상태 변경";
        case resource_1.RefAuditReasonKey.StudySubjectSubjectNoUpdated:
            return lang === common_1.LoLang.EN ? "Subject No. Updated" : "SubjectNo 변경";
        case resource_1.RefAuditReasonKey.StudySubjectAllocated:
            return lang === common_1.LoLang.EN ? "Subject Allocated" : "Subject Allocated";
        case resource_1.RefAuditReasonKey.StudySubjectRandomized:
            return lang === common_1.LoLang.EN ? "Subject Randomized" : "Subject Randomized";
        case resource_1.RefAuditReasonKey.StudySubjectAgeUpdated:
            return lang === common_1.LoLang.EN ? "Subject Age Updated" : "Subject 나이 변경";
        case resource_1.RefAuditReasonKey.StudySubjectSexUpdated:
            return lang === common_1.LoLang.EN ? "Subject Sex Updated" : "Subject 성별 변경";
        case resource_1.RefAuditReasonKey.StudySubjectBirthDateUpdated:
            return lang === common_1.LoLang.EN ? "Subject Birth Updated" : "Subject 생일 변경";
        case resource_1.RefAuditReasonKey.StudySubjectIcfApprovedDateUpdated:
            return lang === common_1.LoLang.EN ? "Subject Date of Informed Consent Updated" : "Subject 동의서서명일 변경";
        case resource_1.RefAuditReasonKey.StudySubjectECoaAccessCodeUpdated:
            return lang === common_1.LoLang.EN ? "Subject eCOA Access Code Updated" : "Subject eCOA Access Code 변경";
        case resource_1.RefAuditReasonKey.StudySubjectStatusUpdatedToRegistration:
            return lang === common_1.LoLang.EN ? "Subject Registration" : "Subject Registration";
        case resource_1.RefAuditReasonKey.StudySubjectStatusUpdatedToEnrolled:
            return lang === common_1.LoLang.EN ? "Subject Enrolled" : "Subject Enrolled";
        case resource_1.RefAuditReasonKey.StudySubjectStatusUpdatedToScreening:
            return lang === common_1.LoLang.EN ? "Subject Screening" : "Subject Screening";
        case resource_1.RefAuditReasonKey.StudySubjectStatusUpdatedToScreeningFailed:
            return lang === common_1.LoLang.EN ? "Subject Screening Failed" : "Subject Screening Failed";
        case resource_1.RefAuditReasonKey.StudySubjectStatusUpdatedToOngoing:
            return lang === common_1.LoLang.EN ? "Subject Ongoing" : "Subject Ongoing";
        case resource_1.RefAuditReasonKey.StudySubjectStatusUpdatedToDroppedOut:
            return lang === common_1.LoLang.EN ? "Subject Dropped Out" : "Subject Dropped Out";
        case resource_1.RefAuditReasonKey.StudySubjectStatusUpdatedToCompleted:
            return lang === common_1.LoLang.EN ? "Subject Completed" : "Subject Completed";
        case resource_1.RefAuditReasonKey.StudySubjectVisitDateUpdated:
            return lang === common_1.LoLang.EN ? "Subject Visit Date Updated" : "Subject 방문 정보 변경";
        case resource_1.RefAuditReasonKey.StudySubjectReservedUpdated:
            return lang === common_1.LoLang.EN ? "Subject Reserved Updated" : "Subject Reserved 정보 변경";
        case resource_1.RefAuditReasonKey.StudySubjectUnblindRequest:
            return lang === common_1.LoLang.EN ? "Subject Unblind Requested" : "Subject Blind 해제 요청";
        case resource_1.RefAuditReasonKey.StudySubjectUnblindApprove:
            return lang === common_1.LoLang.EN ? "Subject Unblind Approved" : "Subject Blind 해제 승인";
        case resource_1.RefAuditReasonKey.StudySubjectUnblindForce:
            return lang === common_1.LoLang.EN ? "Subject Unblinded (Privileged)" : "Subject Blind 해제 (Force)";
        case resource_1.RefAuditReasonKey.StudySubjectUnblindForceUnderConds:
            return lang === common_1.LoLang.EN ? "Subject Unblinded (Under Conditions)" : "Subject Blind 해제 (명시된 조건 만족)";
        case resource_1.RefAuditReasonKey.StudySubjectTriggerInvokeAllExplicitly:
            return lang === common_1.LoLang.EN ? "Subject Trigger Invoke All Explicitly" : "Subject 전체 Trigger 재수행";
        case resource_1.RefAuditReasonKey.StudySubjectCrfRefresh:
            return lang === common_1.LoLang.EN ? "Subject CRF Refresh" : "Subject CRF Refresh";
        case resource_1.RefAuditReasonKey.StudySubjectCrfDisabled:
        case resource_1.RefAuditReasonKey.StudySubjectCrfActivated:
            return lang === common_1.LoLang.EN ? "Subject CRF Disabling State Changed" : "Subject CRF 활성화 상태 변경";
        case resource_1.RefAuditReasonKey.StudySubjectCrfPageAdd:
            return lang === common_1.LoLang.EN ? "CRF Page Added" : "CRF page 추가";
        case resource_1.RefAuditReasonKey.StudySubjectCrfInit:
            return lang === common_1.LoLang.EN ? "Subject CRF initialized" : "Subject CRF 초기화";
        case resource_1.RefAuditReasonKey.StudyUatOpen:
            return lang === common_1.LoLang.EN ? "UAT Sequence Opened" : "UAT Sequence 시작";
        case resource_1.RefAuditReasonKey.StudyUatClose:
            return lang === common_1.LoLang.EN ? "UAT Sequence Closed" : "UAT Sequence 종료";
        case resource_1.RefAuditReasonKey.StudyUatMovedToNextSequence:
            return lang === common_1.LoLang.EN ? "UAT Sequence Changed" : "UAT Sequence 변경";
        case resource_1.RefAuditReasonKey.StudyUatSubmitted:
            return lang === common_1.LoLang.EN ? "UAT Submitted" : "UAT Submitted";
        case resource_1.RefAuditReasonKey.StudyUatAccepted:
            return lang === common_1.LoLang.EN ? "UAT Accepted" : "UAT Accepted";
        case resource_1.RefAuditReasonKey.StudyUatApplied:
            return lang === common_1.LoLang.EN ? "UAT Applied" : "UAT Applied";
        case resource_1.RefAuditReasonKey.StudyUatCompleted:
            return lang === common_1.LoLang.EN ? "UAT Completed" : "UAT Completed";
        case resource_1.RefAuditReasonKey.StudyUatCanceled:
            return lang === common_1.LoLang.EN ? "UAT Canceled" : "UAT Canceled";
        case resource_1.RefAuditReasonKey.StudyUatAutoCanceled:
            return lang === common_1.LoLang.EN ? "UAT Auto-Canceled" : "UAT Auto-Canceled";
        case resource_1.RefAuditReasonKey.StudyUatMigrated:
            return lang === common_1.LoLang.EN ? "UAT Migrated" : "UAT Migrated";
        case resource_1.RefAuditReasonKey.StudyUatCommentAdded:
            return lang === common_1.LoLang.EN ? "UAT Comment Added" : "UAT Comment Added";
        case resource_1.RefAuditReasonKey.StudyUatCommentUpdated:
            return lang === common_1.LoLang.EN ? "UAT Comment Updated" : "UAT Comment Updated";
        case resource_1.RefAuditReasonKey.StudyUatCommentMigrated:
            return lang === common_1.LoLang.EN ? "UAT Comment Migrated" : "UAT Comment Migrated";
        case resource_1.RefAuditReasonKey.StudySubjectCycleLikeVisitsAdded:
            return lang === common_1.LoLang.EN ? "Subject Cycle Added" : "Subject Cycle 추가";
        case resource_1.RefAuditReasonKey.StudySubjectCycleLikeVisitsRemoved:
            return lang === common_1.LoLang.EN ? "Subject Cycle Removed" : "Subject Cycle 삭제";
        case resource_1.RefAuditReasonKey.StudyCustomDataCrfFileCreated:
            return lang === common_1.LoLang.EN ? "Created" : "Created";
        case resource_1.RefAuditReasonKey.StudyCustomDataCrfFileRequested:
            return lang === common_1.LoLang.EN ? "Requested" : "Requested";
        case resource_1.RefAuditReasonKey.StudyCustomDataCrfFileDownloaded:
            return lang === common_1.LoLang.EN ? "Downloaded" : "Downloaded";
        case resource_1.RefAuditReasonKey.StudyDuplicatedCrfPageDestroyed:
            return lang === common_1.LoLang.EN
                ? "Delete CRF page - Duplicated page created due to system error"
                : "CRF page 삭제 - System 오류에 따른 중복 생성";
        default:
            return reason.key || "(Unknown)";
    }
}
exports.readableRefAuditReason = readableRefAuditReason;
function readableEcoaVisitStatus(status, lang, defaultVal = "Unknown") {
    switch (status) {
        case ecoaVisit_1.EcoaVisitStatus.Done:
            return lang === common_1.LoLang.EN ? "Complete" : "완료";
        case ecoaVisit_1.EcoaVisitStatus.NotAvailable:
            return lang === common_1.LoLang.EN ? "Not Available" : "입력 불가";
        case ecoaVisit_1.EcoaVisitStatus.NotDone:
            return lang === common_1.LoLang.EN ? "Incomplete" : "미완료";
        case ecoaVisit_1.EcoaVisitStatus.Ongoing:
            return lang === common_1.LoLang.EN ? "In Progress" : "진행중";
        default:
            return status || defaultVal;
    }
}
exports.readableEcoaVisitStatus = readableEcoaVisitStatus;
function readableEcoaCrfStatus(status, lang, defaultVal = "Unknown") {
    switch (status) {
        case ecoaCrf_1.EcoaCrfStatus.Done:
            return lang === common_1.LoLang.EN ? "Complete" : "완료";
        case ecoaCrf_1.EcoaCrfStatus.NotAvailable:
            return lang === common_1.LoLang.EN ? "Not Available" : "입력 불가";
        case ecoaCrf_1.EcoaCrfStatus.NotDone:
            return lang === common_1.LoLang.EN ? "Incomplete" : "미완료";
        case ecoaCrf_1.EcoaCrfStatus.Ongoing:
            return lang === common_1.LoLang.EN ? "In Progress" : "진행중";
        default:
            return status || defaultVal;
    }
}
exports.readableEcoaCrfStatus = readableEcoaCrfStatus;
function readableSubjectSigningStatus(status, lang, defaultVal = "Unknown") {
    switch (status) {
        case studySubject_1.StudySubjectSigningStatus.Incomplete:
            return lang === common_1.LoLang.EN ? "Incomplete" : "미완료";
        case studySubject_1.StudySubjectSigningStatus.PartiallyCompleted:
            return lang === common_1.LoLang.EN ? "Partially Completed" : "부분완료";
        case studySubject_1.StudySubjectSigningStatus.Completed:
            return lang === common_1.LoLang.EN ? "Completed" : "완료";
        default:
            return status || defaultVal;
    }
}
exports.readableSubjectSigningStatus = readableSubjectSigningStatus;
function readableSubjectBlindAction(action, lang, defaultVal = "Unknown") {
    switch (action) {
        case studySubjectBlindAction_1.StudySubjectBlindActionType.UnblindRequest:
            return lang === common_1.LoLang.EN ? "Unblind Request" : "눈가림 해제 요청";
        case studySubjectBlindAction_1.StudySubjectBlindActionType.UnblindApprove:
            return lang === common_1.LoLang.EN ? "Unblind Approve" : "눈가림 해제 승인";
        case studySubjectBlindAction_1.StudySubjectBlindActionType.UnblindForce:
            return lang === common_1.LoLang.EN ? "Unblind Force" : "강제 눈가림 해제";
        case studySubjectBlindAction_1.StudySubjectBlindActionType.UnblindForceUnderConds:
            return lang === common_1.LoLang.EN ? "Unblind (Under Conditions)" : "눈가림 해제 (명시된 조건 만족)";
        default:
            return action || defaultVal;
    }
}
exports.readableSubjectBlindAction = readableSubjectBlindAction;
function readableFaqCategory(category, defaultVal = "-") {
    switch (category) {
        case faq_1.FaqCategory.EDC:
            return "EDC";
        case faq_1.FaqCategory.STUDY:
            return "Study";
        default:
            return category || defaultVal;
    }
}
exports.readableFaqCategory = readableFaqCategory;
function readableAffiliationType(affiliationType, defaultVal = "-") {
    switch (affiliationType) {
        case affiliation_1.AffiliationType.Cro:
            return "CRO";
        case affiliation_1.AffiliationType.Site:
            return "Site";
        case affiliation_1.AffiliationType.Sponsor:
            return "Sponsor";
        case affiliation_1.AffiliationType.System:
            return "System";
        default:
            return affiliationType || defaultVal;
    }
}
exports.readableAffiliationType = readableAffiliationType;
function convertAffiliationTypeToUrlString(affiliationType, defaultVal = "-") {
    switch (affiliationType) {
        case affiliation_1.AffiliationType.Cro:
            return "cros";
        case affiliation_1.AffiliationType.Site:
            return "sites";
        case affiliation_1.AffiliationType.Sponsor:
            return "sponsors";
        default:
            return affiliationType || defaultVal;
    }
}
exports.convertAffiliationTypeToUrlString = convertAffiliationTypeToUrlString;
function readableStudyStatus(status, defaultVal = "-") {
    switch (status) {
        case study_1.StudyStatus.Wait:
            return "Wait";
        case study_1.StudyStatus.Ongoing:
            return "Ongoing";
        case study_1.StudyStatus.Closed:
            return "Closed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyStatus = readableStudyStatus;
function readableStudySubjectStatus(status, lang = common_1.LoLang.KO, defaultVal = "-") {
    if (lang === "KO") {
        switch (status) {
            case studySubject_1.StudySubjectStatus.Enrolled:
                return "등록";
            case studySubject_1.StudySubjectStatus.Screening:
                return "스크리닝";
            case studySubject_1.StudySubjectStatus.ScreeningFailed:
                return "스크리닝 탈락";
            case studySubject_1.StudySubjectStatus.Ongoing:
                return "진행 중";
            case studySubject_1.StudySubjectStatus.DroppedOut:
                return "중도탈락";
            case studySubject_1.StudySubjectStatus.Completed:
                return "완료";
            case studySubject_1.StudySubjectStatus.NotAvailable:
                return "N/A";
            case studySubject_1.StudySubjectStatus.Registering:
                return "등록 중";
            case studySubject_1.StudySubjectStatus.Registration:
                return "접수";
            default:
                return status || defaultVal;
        }
    }
    else if (lang === "EN") {
        switch (status) {
            case studySubject_1.StudySubjectStatus.Enrolled:
                return "Enrolled";
            case studySubject_1.StudySubjectStatus.Screening:
                return "Screening";
            case studySubject_1.StudySubjectStatus.ScreeningFailed:
                return "Screening Failed";
            case studySubject_1.StudySubjectStatus.Ongoing:
                return "Ongoing";
            case studySubject_1.StudySubjectStatus.DroppedOut:
                return "Dropped Out";
            case studySubject_1.StudySubjectStatus.Completed:
                return "Completed";
            case studySubject_1.StudySubjectStatus.NotAvailable:
                return "N/A";
            case studySubject_1.StudySubjectStatus.Registering:
                return "Registering";
            case studySubject_1.StudySubjectStatus.Registration:
                return "Registration";
            default:
                return status || defaultVal;
        }
    }
    else {
        switch (status) {
            case studySubject_1.StudySubjectStatus.Enrolled:
                return "등록 (Enrolled)";
            case studySubject_1.StudySubjectStatus.Screening:
                return "스크리닝 (Screening)";
            case studySubject_1.StudySubjectStatus.ScreeningFailed:
                return "스크리닝 탈락 (Screening Failed)";
            case studySubject_1.StudySubjectStatus.Ongoing:
                return "진행 중 (Ongoing)";
            case studySubject_1.StudySubjectStatus.DroppedOut:
                return "중도탈락 (Dropped Out)";
            case studySubject_1.StudySubjectStatus.Completed:
                return "완료 (Completed)";
            case studySubject_1.StudySubjectStatus.NotAvailable:
                return "N/A (Not Available)";
            case studySubject_1.StudySubjectStatus.Registering:
                return "등록 중 (Registering)";
            case studySubject_1.StudySubjectStatus.Registration:
                return "접수 (Registration)";
            default:
                return status || defaultVal;
        }
    }
}
exports.readableStudySubjectStatus = readableStudySubjectStatus;
function readableStudyQueryType(status, defaultVal = "-") {
    switch (status) {
        case studyQuery_1.StudyQueryType.Auto:
            return "Auto";
        case studyQuery_1.StudyQueryType.Manual:
            return "Manual";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyQueryType = readableStudyQueryType;
function readableStudyQueryStatus(status, defaultVal = "-") {
    switch (status) {
        case studyQuery_1.StudyQueryStatus.Open:
            return "Open";
        case studyQuery_1.StudyQueryStatus.Resolving:
            return "Resolving";
        case studyQuery_1.StudyQueryStatus.Cancelled:
        case studyQuery_1.StudyQueryStatus.ForceCancelled:
        case studyQuery_1.StudyQueryStatus.Resolved:
        case studyQuery_1.StudyQueryStatus.ForceResolved:
        case studyQuery_1.StudyQueryStatus.Claimed:
        case studyQuery_1.StudyQueryStatus.ForceClaimed:
        case studyQuery_1.StudyQueryStatus.AutoClosed:
            return "Closed";
        case studyQuery_1.StudyQueryStatus.Pending:
            return "Pending";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyQueryStatus = readableStudyQueryStatus;
function readableStudyCaptureSummaryStatus(status, defaultVal = "-", lang) {
    if (lang === "EN") {
        switch (status) {
            case studyCaptureSummaryStatus_1.StudyCaptureSummaryStatus.NotAvailable:
                return "N/A";
            case studyCaptureSummaryStatus_1.StudyCaptureSummaryStatus.InComplete:
                return "Incomplete";
            case studyCaptureSummaryStatus_1.StudyCaptureSummaryStatus.PartiallyCompleted:
                return "Partially Completed";
            case studyCaptureSummaryStatus_1.StudyCaptureSummaryStatus.Completed:
                return "Completed";
            default:
                return status || defaultVal;
        }
    }
    else {
        switch (status) {
            case studyCaptureSummaryStatus_1.StudyCaptureSummaryStatus.NotAvailable:
                return "N/A";
            case studyCaptureSummaryStatus_1.StudyCaptureSummaryStatus.InComplete:
                return "미완료";
            case studyCaptureSummaryStatus_1.StudyCaptureSummaryStatus.PartiallyCompleted:
                return "부분완료";
            case studyCaptureSummaryStatus_1.StudyCaptureSummaryStatus.Completed:
                return "완료";
            default:
                return status || defaultVal;
        }
    }
}
exports.readableStudyCaptureSummaryStatus = readableStudyCaptureSummaryStatus;
function readableStudySubjectSigningStatus(signingStatus, lang = common_1.LoLang.KO, defaultVal = "-") {
    if (lang === "KO") {
        switch (signingStatus) {
            case studySubject_1.StudySubjectSigningStatus.Completed:
                return "완료";
            case studySubject_1.StudySubjectSigningStatus.Incomplete:
                return "미완료";
            case studySubject_1.StudySubjectSigningStatus.PartiallyCompleted:
                return "부분완료";
            default:
                return signingStatus || defaultVal;
        }
    }
    else if (lang === "EN") {
        switch (signingStatus) {
            case studySubject_1.StudySubjectSigningStatus.Completed:
                return "Completed";
            case studySubject_1.StudySubjectSigningStatus.Incomplete:
                return "InCompleted";
            case studySubject_1.StudySubjectSigningStatus.PartiallyCompleted:
                return "Partially Completed";
            default:
                return signingStatus || defaultVal;
        }
    }
    else {
        switch (signingStatus) {
            case studySubject_1.StudySubjectSigningStatus.Completed:
                return "완료 (Completed)";
            case studySubject_1.StudySubjectSigningStatus.Incomplete:
                return "미완료 (InCompleted)";
            case studySubject_1.StudySubjectSigningStatus.PartiallyCompleted:
                return "부분완료 (Partially Completed)";
            default:
                return signingStatus || defaultVal;
        }
    }
}
exports.readableStudySubjectSigningStatus = readableStudySubjectSigningStatus;
function readableStudySubjectSex(sex, lang) {
    if (!sex)
        return null;
    if (lang === "KO") {
        return (sex === null || sex === void 0 ? void 0 : sex.ko) || "";
    }
    else if (lang === "EN") {
        return `${sex.en}`;
    }
    else {
        return `${sex === null || sex === void 0 ? void 0 : sex.ko} (${sex.en})`;
    }
}
exports.readableStudySubjectSex = readableStudySubjectSex;
function readableLabelObject(label, val) {
    return `${(label === null || label === void 0 ? void 0 : label.prefix) || ""}${String(val).padStart((label === null || label === void 0 ? void 0 : label.minlen) || 0, "0")}${(label === null || label === void 0 ? void 0 : label.suffix) || ""}`;
}
exports.readableLabelObject = readableLabelObject;
function readableCrfFolderType(folderType, defaultVal = "-") {
    switch (folderType) {
        case "NORMAL_VISIT":
            return "Normal Visit";
        case "ALL_VISIT":
            return "All Visit";
        case "UNSCHEDULED_VISIT":
            return "Unscheduled Visit";
        case "REPORT_SAE":
            return "SAE Report";
        case "REPORT_AE":
            return "AE Report";
        case "REPORT_PREGNANCY":
            return "Pregnancy Report";
        default:
            return folderType || defaultVal;
    }
}
exports.readableCrfFolderType = readableCrfFolderType;
function readableVisitName(visitId, visitSeq, studySpec) {
    const found = studySpec.folders
        .map(folder => {
        return folder.visits.find(visit => visit.id === visitId);
    })
        .find(e => typeof e === "object");
    if (typeof (found === null || found === void 0 ? void 0 : found.label) === "object") {
        return readableLabelObject(found.label, visitSeq);
    }
    return visitId;
}
exports.readableVisitName = readableVisitName;
function readableStudyReportStatus(status, sequence, defaultVal = "-") {
    switch (status) {
        case studyReport_1.StudyReportStatus.Initial:
        case studyReport_1.StudyReportStatus.FollowUp:
            return `Report #${sequence} Created`;
        case studyReport_1.StudyReportStatus.InitialCapture:
        case studyReport_1.StudyReportStatus.FollowUpCapture:
            return `Report #${sequence} Saved`;
        case studyReport_1.StudyReportStatus.InitialSubmission:
        case studyReport_1.StudyReportStatus.FollowUpSubmission:
            return `Report #${sequence} Submitted`;
        default:
            return status || defaultVal;
    }
}
exports.readableStudyReportStatus = readableStudyReportStatus;
function readableInquiryType(type, defaultVal = "-", lang) {
    switch (type) {
        case inquiry_1.InquiryType.study:
            return lang === common_1.LoLang.EN ? "Study related Inquiry" : "Study 관련 질의";
        case inquiry_1.InquiryType.system:
            return lang === common_1.LoLang.EN ? "System related Inquiry" : "System 관련 질의";
        default:
            return type || defaultVal;
    }
}
exports.readableInquiryType = readableInquiryType;
function readableInquiryCategory(category, defaultVal = "-", lang) {
    switch (category) {
        case inquiry_1.InquiryCategory.sponsor:
            return lang === common_1.LoLang.EN ? "Sponsor Registration / Sponsor related Inquiry" : "신규 Sponsor 등록 및 Sponsor 정보 변경 문의";
        case inquiry_1.InquiryCategory.cro:
            return lang === common_1.LoLang.EN ? "CRO Registration / CRO related Inquiry" : "신규 CRO 등록 및 CRO 정보 변경 문의";
        case inquiry_1.InquiryCategory.site:
            return lang === common_1.LoLang.EN ? "Site Registration / Site related Inquiry" : "신규 Site 등록 및 Site 정보 변경 문의";
        case inquiry_1.InquiryCategory.account:
            return lang === common_1.LoLang.EN ? "Account related Inquiry" : "계정 관련 문의";
        case inquiry_1.InquiryCategory.study:
            return lang === common_1.LoLang.EN ? "Study related Inquiry" : "Study 관련 문의";
        case inquiry_1.InquiryCategory.edc:
            return lang === common_1.LoLang.EN ? "EDC related Inquiry" : "EDC 사용 관련 문의";
        case inquiry_1.InquiryCategory.etc:
            return lang === common_1.LoLang.EN ? "Other Inquiry" : "기타 문의";
        default:
            return category || defaultVal;
    }
}
exports.readableInquiryCategory = readableInquiryCategory;
function readableStudyUatCategory(category, defaultVal = "-") {
    switch (category) {
        case studyUat_1.StudyUatCategory.EntryScreen:
            return "Entry Screen";
        case studyUat_1.StudyUatCategory.Trigger:
            return "Trigger";
        case studyUat_1.StudyUatCategory.Role:
            return "Role";
        case studyUat_1.StudyUatCategory.Privilege:
            return "Privilege";
        case studyUat_1.StudyUatCategory.Other:
            return "Other";
        default:
            return category || defaultVal;
    }
}
exports.readableStudyUatCategory = readableStudyUatCategory;
function readableStudyUatStatus(status, defaultVal = "-") {
    switch (status) {
        case studyUat_1.StudyUatStatus.Submitted:
            return "Submitted";
        case studyUat_1.StudyUatStatus.Accepted:
            return "Accepted";
        case studyUat_1.StudyUatStatus.Applied:
            return "Applied";
        case studyUat_1.StudyUatStatus.Completed:
            return "Completed";
        case studyUat_1.StudyUatStatus.Cancelled:
            return "Canceled";
        case studyUat_1.StudyUatStatus.AutoCanceled:
            return "Auto-Canceled";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyUatStatus = readableStudyUatStatus;
function readableStudyUatVerbStatus(status, defaultVal = "-") {
    switch (status) {
        case studyUat_1.StudyUatStatus.Accepted:
            return "Accept";
        case studyUat_1.StudyUatStatus.Applied:
            return "Change to Applied";
        case studyUat_1.StudyUatStatus.Completed:
            return "Change to Completed";
        case studyUat_1.StudyUatStatus.Cancelled:
            return "Cancel";
        default:
            return readableStudyUatStatus(status, defaultVal);
    }
}
exports.readableStudyUatVerbStatus = readableStudyUatVerbStatus;
function readableStudyRoleUploadStatus(status, defaultVal = "-") {
    switch (status) {
        case studyRole_1.StudyRoleUploadStatus.Wait:
            return "Wait";
        case studyRole_1.StudyRoleUploadStatus.Processing:
            return "Processing";
        case studyRole_1.StudyRoleUploadStatus.Processed:
            return "Processed";
        case studyRole_1.StudyRoleUploadStatus.Failed:
            return "Failed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyRoleUploadStatus = readableStudyRoleUploadStatus;
function readableStudyRandomizationUploadStatus(status, defaultVal = "-") {
    switch (status) {
        case studyRandomization_1.StudyRandomizationUploadStatus.Wait:
            return "Wait";
        case studyRandomization_1.StudyRandomizationUploadStatus.Processing:
            return "Processing";
        case studyRandomization_1.StudyRandomizationUploadStatus.Processed:
            return "Processed";
        case studyRandomization_1.StudyRandomizationUploadStatus.Failed:
            return "Failed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyRandomizationUploadStatus = readableStudyRandomizationUploadStatus;
function readableNotificationStatus(notificationStatus, notificationQueueStatus, defaultVal = "-") {
    switch (notificationQueueStatus) {
        case entity_1.NotificationQueueStatus.Sent:
            return "Sent";
        case entity_1.NotificationQueueStatus.Sending:
            return "Sending ..";
        case entity_1.NotificationQueueStatus.Failed:
            return "Failed";
        case entity_1.NotificationQueueStatus.Wait:
        default:
            switch (notificationStatus) {
                case entity_1.NotificationStatus.Wait:
                    return "Wait";
                case entity_1.NotificationStatus.Preparing:
                    return "Preparing ..";
                case entity_1.NotificationStatus.Prepared:
                    return "Prepared";
                case entity_1.NotificationStatus.Done:
                    return "Done";
                case entity_1.NotificationStatus.Broken:
                    return "Error";
                case entity_1.NotificationStatus.Failed:
                    return "Failed";
                default:
                    return notificationQueueStatus || notificationStatus || defaultVal;
            }
    }
}
exports.readableNotificationStatus = readableNotificationStatus;
function offsetToTimezone(offset) {
    const absOffset = offset < 0 ? offset * -1 : offset;
    const sign = offset < 0 ? "-" : "+";
    const hh = String(Math.floor(absOffset / 60)).padStart(2, "0");
    const mm = String(absOffset % 60).padStart(2, "0");
    return `${sign}${hh}:${mm}`;
}
exports.offsetToTimezone = offsetToTimezone;
function readableStudyQueryUploadDetailValidateStatus(status, defaultVal = "-") {
    switch (status) {
        case studyQuery_1.StudyQueryUploadDetailValidateStatus.Wait:
            return "Wait";
        case studyQuery_1.StudyQueryUploadDetailValidateStatus.Processing:
            return "Processing";
        case studyQuery_1.StudyQueryUploadDetailValidateStatus.Succeed:
            return "Succeed";
        case studyQuery_1.StudyQueryUploadDetailValidateStatus.Failed:
            return "Failed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyQueryUploadDetailValidateStatus = readableStudyQueryUploadDetailValidateStatus;
function readableStudyQueryUploadDetailApplyStatus(status, defaultVal = "-") {
    switch (status) {
        case studyQuery_1.StudyQueryUploadDetailApplyStatus.None:
            return "None";
        case studyQuery_1.StudyQueryUploadDetailApplyStatus.Wait:
            return "Wait";
        case studyQuery_1.StudyQueryUploadDetailApplyStatus.Processing:
            return "Processing";
        case studyQuery_1.StudyQueryUploadDetailApplyStatus.Succeed:
            return "Succeed";
        case studyQuery_1.StudyQueryUploadDetailApplyStatus.Failed:
            return "Failed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyQueryUploadDetailApplyStatus = readableStudyQueryUploadDetailApplyStatus;
function readableStudyQueryUploadValidateStatus(status, defaultVal = "-") {
    switch (status) {
        case studyQuery_1.StudyQueryUploadValidateStatus.Wait:
            return "Wait";
        case studyQuery_1.StudyQueryUploadValidateStatus.Processing:
            return "Processing";
        case studyQuery_1.StudyQueryUploadValidateStatus.PartiallySucceed:
            return "Partially Succeed";
        case studyQuery_1.StudyQueryUploadValidateStatus.Succeed:
            return "All Succeed";
        case studyQuery_1.StudyQueryUploadValidateStatus.Failed:
            return "Failed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyQueryUploadValidateStatus = readableStudyQueryUploadValidateStatus;
function readableStudyQueryUploadApplyStatus(status, defaultVal = "-") {
    switch (status) {
        case studyQuery_1.StudyQueryUploadApplyStatus.None:
            return "None";
        case studyQuery_1.StudyQueryUploadApplyStatus.Wait:
            return "Wait";
        case studyQuery_1.StudyQueryUploadApplyStatus.Processing:
            return "Processing";
        case studyQuery_1.StudyQueryUploadApplyStatus.PartiallySucceed:
            return "Partially Succeed";
        case studyQuery_1.StudyQueryUploadApplyStatus.Succeed:
            return "All Succeed";
        case studyQuery_1.StudyQueryUploadApplyStatus.Failed:
            return "Failed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyQueryUploadApplyStatus = readableStudyQueryUploadApplyStatus;
function readableStudyQueryUploadDetailStatus(status, defaultVal = "-") {
    switch (status) {
        case studyQuery_1.StudyQueryUploadDetailStatus.Open:
            return "Open";
        case studyQuery_1.StudyQueryUploadDetailStatus.InvalidData:
            return "Invalid Data";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyQueryUploadDetailStatus = readableStudyQueryUploadDetailStatus;
function readableStudyIpDeliveryStatus(status, defaultVal = "-") {
    switch (status) {
        case studyIp_1.StudyIpDeliveryStatus.AutoRequested:
            return "Auto Requested";
        case studyIp_1.StudyIpDeliveryStatus.Requested:
            return "Requested";
        case studyIp_1.StudyIpDeliveryStatus.Approved:
            return "Approved";
        case studyIp_1.StudyIpDeliveryStatus.Started:
            return "On Delivery";
        case studyIp_1.StudyIpDeliveryStatus.Delivered:
            return "Delivered";
        case studyIp_1.StudyIpDeliveryStatus.Canceled:
            return "Canceled";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyIpDeliveryStatus = readableStudyIpDeliveryStatus;
function readableStudyIpInfoType(status, defaultVal = "-") {
    switch (status) {
        case studyIp_1.StudyIpInfoType.RunIn:
            return "Run In";
        case studyIp_1.StudyIpInfoType.Treatment:
            return "Treatment";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyIpInfoType = readableStudyIpInfoType;
function readableStudyIpReturnStatus(status, lang, defaultVal = "-") {
    switch (status) {
        case studyIp_1.StudyIpReturnStatus.Requested:
            return lang === common_1.LoLang.EN ? "Return Requested" : "반납 요청";
        case studyIp_1.StudyIpReturnStatus.Returned:
            return lang === common_1.LoLang.EN ? "Return Completed" : "반납 완료";
        case studyIp_1.StudyIpReturnStatus.Canceled:
            return lang === common_1.LoLang.EN ? "Return Canceled" : "반납 취소";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyIpReturnStatus = readableStudyIpReturnStatus;
function readableStudyDigestType(status, defaultVal = "-") {
    switch (status) {
        case studyDigest_1.StudyDigestType.Capture:
            return "Data Capture";
        case studyDigest_1.StudyDigestType.QueryMessage:
            return "Query Message";
        case studyDigest_1.StudyDigestType.QueryStatus:
            return "Query Status";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyDigestType = readableStudyDigestType;
function readableStudyDigestHashingStatus(status, defaultVal = "-") {
    switch (status) {
        case studyDigest_1.StudyDigestHashingStatus.Wait:
            return "Wait";
        case studyDigest_1.StudyDigestHashingStatus.Processing:
            return "Processing";
        case studyDigest_1.StudyDigestHashingStatus.Done:
            return "Done";
        case studyDigest_1.StudyDigestHashingStatus.Failed:
            return "Failed";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyDigestHashingStatus = readableStudyDigestHashingStatus;
function readableStudyDigestVerificationStatus(status, defaultVal = "-") {
    switch (status) {
        case studyDigest_1.StudyDigestVerificationStatus.Wait:
            return "Wait";
        case studyDigest_1.StudyDigestVerificationStatus.Valid:
            return "Valid";
        case studyDigest_1.StudyDigestVerificationStatus.Invalid:
            return "Invalid";
        default:
            return status || defaultVal;
    }
}
exports.readableStudyDigestVerificationStatus = readableStudyDigestVerificationStatus;
function readableStudyIpAccountabilityBySubjectType(type, defaultVal = "-") {
    switch (type) {
        case studyIp_1.StudyIpAccountabilityBySubjectType.Dispense:
            return "Dispense";
        case studyIp_1.StudyIpAccountabilityBySubjectType.Return:
            return "Return";
        default:
            return type || defaultVal;
    }
}
exports.readableStudyIpAccountabilityBySubjectType = readableStudyIpAccountabilityBySubjectType;
function convertFlagToReadableText(value, isDisabled, lang) {
    if (isDisabled)
        return "N/A";
    else if (lang === "EN") {
        return value ? "Complete" : "Incomplete";
    }
    else {
        return value ? "완료" : "미완료";
    }
}
exports.convertFlagToReadableText = convertFlagToReadableText;
// NOTE: ActivateAt, TerminateAt이 null인 경우, isInitial === true.
function readableStudyUserActivateStatus(isEnabled, isInitial, lang = common_1.LoLang.EN) {
    if (isEnabled) {
        if (lang === "EN") {
            return "Activated";
        }
        else {
            return "활성화";
        }
    }
    else {
        if (isInitial) {
            return "-";
        }
        if (lang === "EN") {
            return "Inactivated";
        }
        else {
            return "비활성화";
        }
    }
}
exports.readableStudyUserActivateStatus = readableStudyUserActivateStatus;
function readableStudyPhase(studyPhase, studyPhaseDisp) {
    if (!studyPhase)
        return null;
    if (studyPhase === consts_1.StudyPhase.OTHER)
        return studyPhaseDisp;
    return `${consts_1.StudyPhaseDisp[studyPhase].ko} ${consts_1.StudyPhaseDisp[studyPhase].ko !== consts_1.StudyPhaseDisp[studyPhase].en ? `(${consts_1.StudyPhaseDisp[studyPhase].en})` : ""}`.trim();
}
exports.readableStudyPhase = readableStudyPhase;
function readableSubjectCrfDisablingStatus(status, lang, defaultVal = "Unknown") {
    switch (status) {
        case entity_1.StudySubjectCrfDisable.On:
            return lang === common_1.LoLang.EN ? "Disabled" : "비활성화";
        case entity_1.StudySubjectCrfDisable.Off:
            return lang === common_1.LoLang.EN ? "Actived" : "활성화";
        default:
            return status || defaultVal;
    }
}
exports.readableSubjectCrfDisablingStatus = readableSubjectCrfDisablingStatus;
function readableMedicalCodingEntryType(entryType, defaultVal = "-", value) {
    if (entryType === entity_1.MedicalCodingEntryType.Meddra)
        return "MedDRA";
    else if (entryType === entity_1.MedicalCodingEntryType.AtcIndex)
        return "ATC Index";
    else if (entryType === entity_1.MedicalCodingEntryType.KoDD)
        return "KoDD";
    else if (entryType === entity_1.MedicalCodingEntryType.WhoDDB3)
        return "WHODD B3";
    else if (entryType === entity_1.MedicalCodingEntryType.WhoDDC3)
        return "WHODD C3";
    else if (entryType === entity_1.MedicalCodingEntryType.DirectInput)
        return (value === null || value === void 0 ? void 0 : value.directInput) || "Direct Input";
    return entryType || defaultVal;
}
exports.readableMedicalCodingEntryType = readableMedicalCodingEntryType;
function readableWhoDDColumnType(columnType, defaultVal = "-") {
    switch (columnType) {
        case entity_1.WhoDDB3SearchColumnTypes.DrugCode || entity_1.WhoDDC3SearchColumnTypes.DrugCode:
            return "Drug Code";
        case entity_1.WhoDDB3SearchColumnTypes.DrugName || entity_1.WhoDDC3SearchColumnTypes.DrugName:
            return "Drug Name";
        case entity_1.WhoDDB3SearchColumnTypes.Ingredients || entity_1.WhoDDC3SearchColumnTypes.Ingredients:
            return "Ingredients";
        case entity_1.WhoDDC3SearchColumnTypes.MedicinalprodId:
            return "Medicinalprod Id";
        case entity_1.WhoDDC3SearchColumnTypes.Country:
            return "Country";
        case entity_1.WhoDDC3SearchColumnTypes.Organization:
            return "Organization";
        case entity_1.WhoDDC3SearchColumnTypes.PharmForm:
            return "Pharm Form";
        case entity_1.WhoDDC3SearchColumnTypes.PharmStrength:
            return "Pharm Strength";
        default:
            return columnType || defaultVal;
    }
}
exports.readableWhoDDColumnType = readableWhoDDColumnType;
function readableSubjectSmsType(smsType, defaultVal = "-") {
    switch (smsType) {
        case subjectSms_1.SubjectSmsType.ecoaAccess:
            return "eCOA 인증번호 발송";
        case subjectSms_1.SubjectSmsType.ecoaAuthenticate:
            return "eCOA 2차 인증번호 발송";
        case subjectSms_1.SubjectSmsType.eConsent:
            return "eConsent URL 발송";
        case subjectSms_1.SubjectSmsType.trigger:
            return "시스템 자동 발송";
        default:
            return smsType || defaultVal;
    }
}
exports.readableSubjectSmsType = readableSubjectSmsType;
function readableCycleNumber(cycleNo, lang) {
    return lang === common_1.LoLang.EN ? `${(0, misc_1.getNumericOrdinal)(cycleNo)} Cycle` : `제 ${cycleNo} 주기`;
}
exports.readableCycleNumber = readableCycleNumber;
//# sourceMappingURL=converter.js.map